import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'


const TejaxoTransportationIndustryERP = ({ location }) => {
  //useEffect(() => {
  //  document.title = `Best ERP Software for Transportation Industry${location} | Best Transportation Industry ERP Software${location} | Business Management Solutions - Tejaxo Software`;
  //  document.querySelector('meta[name="description"]').setAttribute(
  //    'content',
  //    `Tejaxo Software is a High Rated Transportation Management ERP Software${location} and BI software for Transportation Management${location}, business management solutions, services and support.`
  //  );
  //  document.querySelector('meta[name="keywords"]').setAttribute(
  //    'content',
  //    `Tejaxo Transportation Management ERP${location}, ERP Software for Transportation Industry Management`
  //  );
  //}, [location]);

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
    <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 about-img">
            <img src="/theme/img/transportation-1-1-1024x683.jpg" alt="Transportation ERP" />
          </div>
          <div className="col-lg-6 content">
            <h1 className="elementor-heading-title elementor-size-default">
              Transportation Industry ERP Software {location}
            </h1>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-lg-6 about-img">
            <h2 className="elementor-heading-title elementor-size-default">
              Technology has helped transform the transportation industry,
            </h2>
            <p>
              allowing many companies to achieve greater economies of scale, bringing down costs and driving growth for the industry. While technology unlocks growth in a sector that is so important to the Indian economy, with digital transformation comes the need to upskill people around new digital processes and hot topics like data security and privacy. To remain competitive, operators need to embrace and understand technology in a way that filters down through the entire business.
            </p>
          </div>
          <div className="col-lg-6 content">
            <img src="/theme/img/transportation-2-1-768x512.jpg" alt="Transportation Growth" />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-lg-6 about-img">
            <img src="/theme/img/bdimg8.JPG" alt="ERP Integration" />
          </div>
          <div className="col-lg-6 content">
            <h2 className="elementor-heading-title elementor-size-default">
              Tejaxo ERP embeds a new digital way of working into your business with easy-to-use tools...
            </h2>
            <p style={{ fontWeight: 400 }}>
              �that allow complete visibility of the complete supply chain, with continuous improvement in mind. We help your business to keep agile with real-time insights that can help you manage every aspect of your operations so you can stay competitive when securing contracts while effectively managing those you already have.
            </p>
          </div>
        </div>
      </div>
            </section>
        </MasterPage>
  );
};

export default TejaxoTransportationIndustryERP;
